import React from "react";
import {Colors} from "../colors";

export const BounceLogo = ({
  color = Colors.primary._800,
  height = "200px",
  width = "40px",
}: {
  color?: string;
  height?: string;
  width?: string;
}) => {
  return (
    <svg style={{width, height}} viewBox="0 0 208 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.205 5.27895C158.635 5.27895 141.959 21.9546 141.959 42.525H136.68C136.68 30.3771 126.832 20.5294 114.684 20.5294C102.536 20.5294 92.6887 30.3771 92.6887 42.525H87.4097C87.4097 27.4617 99.621 15.2504 114.684 15.2504C125.058 15.2504 134.079 21.0415 138.69 29.5672C144.171 12.4179 160.238 0 179.205 0V5.27895Z"
        fill={color}
      />
      <path
        d="M166.537 43.1983C158.793 43.1983 152.925 37.2824 152.925 29.5387C152.925 21.7951 158.793 15.9273 166.537 15.9273C172.982 15.9273 177.984 19.8712 179.427 25.8353H174.136C172.79 22.8532 169.904 21.0256 166.537 21.0256C161.871 21.0256 158.36 24.729 158.36 29.5387C158.36 34.3485 161.92 38.1 166.537 38.1C169.952 38.1 172.693 36.2724 174.088 33.0979H179.475C178.08 39.1582 172.934 43.1983 166.537 43.1983Z"
        fill={color}
      />
      <path
        d="M208 29.6349C208 30.2121 207.952 30.7893 207.856 31.3664H186.789C187.463 35.599 190.493 38.1962 194.725 38.1962C197.852 38.1962 200.353 36.7533 201.747 34.3485H207.375C205.307 39.8315 200.545 43.1983 194.725 43.1983C187.126 43.1983 181.402 37.3305 181.402 29.5387C181.402 21.7951 187.126 15.9273 194.725 15.9273C202.709 15.9273 208 22.0837 208 29.6349ZM194.725 20.7851C190.733 20.7851 187.799 23.1899 186.933 27.0377H202.613C201.651 23.0937 198.717 20.7851 194.725 20.7851Z"
        fill={color}
      />
      <path
        d="M13.852 15.9273C21.7399 15.9273 27.3673 21.747 27.3673 29.5868C27.3673 37.3305 21.7399 43.1983 13.852 43.1983C10.2447 43.1983 7.02218 41.8516 4.71352 39.5911L4.04016 42.5731H0V7.26978H5.33878V18.9574C7.59935 17.0335 10.5333 15.9273 13.852 15.9273ZM13.4672 38.0519C18.3731 38.0519 21.9323 34.4447 21.9323 29.5387C21.9323 24.6809 18.3731 21.0256 13.4672 21.0256C8.56129 21.0256 4.954 24.6809 4.954 29.5387C4.954 34.3966 8.56129 38.0519 13.4672 38.0519Z"
        fill={color}
      />
      <path
        d="M43.647 43.1983C35.6629 43.1983 29.7469 37.3786 29.7469 29.5387C29.7469 21.6989 35.6629 15.9273 43.647 15.9273C51.583 15.9273 57.499 21.747 57.499 29.5387C57.499 37.3786 51.583 43.1983 43.647 43.1983ZM43.647 38.1C48.5529 38.1 52.064 34.5409 52.064 29.5387C52.064 24.5847 48.5529 21.0256 43.647 21.0256C38.693 21.0256 35.1819 24.5847 35.1819 29.5387C35.1819 34.5409 38.693 38.1 43.647 38.1Z"
        fill={color}
      />
      <path
        d="M73.1907 43.1983C66.0242 43.1983 61.3588 38.581 61.3588 31.5588V16.5525H66.6976V30.8374C66.6976 35.3585 69.1505 38.1 73.1907 38.1C77.2308 38.1 79.6357 35.3104 79.6357 30.8374V16.5525H84.9745V31.5588C84.9745 38.581 80.3572 43.1983 73.1907 43.1983Z"
        fill={color}
      />
    </svg>
  );
};
